import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import {
    LuMail,
    LuArrowLeft,
    LuCheck,
    LuCircleAlert,
    LuDollarSign
} from 'react-icons/lu';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');

    const { t } = useLanguage();
    const { forgotPassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await forgotPassword(email);
            setSent(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container auth-container-single">
                <div className="auth-form-section">
                    <div className="auth-form-wrapper">
                        <Link to="/login" className="back-link">
                            <LuArrowLeft /> {t('forgotPassword.backToLogin')}
                        </Link>

                        <div className="auth-header">
                            <div className="auth-logo">
                                <LuDollarSign />
                            </div>
                            <h1>{t('forgotPassword.title')}</h1>
                            <p>{t('forgotPassword.subtitle')}</p>
                        </div>

                        {sent ? (
                            <div className="success-state">
                                <div className="success-icon">
                                    <LuCheck />
                                </div>
                                <h2>{t('forgotPassword.sent')}</h2>
                                <p>{t('forgotPassword.checkEmail')}</p>
                                <p className="email-sent-to">{email}</p>
                                <Link to="/login" className="btn btn-primary btn-block">
                                    {t('forgotPassword.backToLogin')}
                                </Link>
                            </div>
                        ) : (
                            <>
                                {error && (
                                    <div className="auth-error">
                                        <LuCircleAlert className="error-icon" />
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit} className="auth-form">
                                    <div className="form-group">
                                        <label>{t('auth.email')}</label>
                                        <div className="input-with-icon">
                                            <LuMail className="input-icon" />
                                            <input
                                                type="email"
                                                className="form-input has-icon"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder={t('auth.emailPlaceholder')}
                                                required
                                                autoComplete="email"
                                            />
                                        </div>
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-block"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-small"></span>
                                                {t('loading.loading')}
                                            </>
                                        ) : (
                                            t('forgotPassword.send')
                                        )}
                                    </button>
                                </form>

                                <p className="auth-footer">
                                    <Link to="/login" className="auth-link">
                                        {t('forgotPassword.backToLogin')}
                                    </Link>
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
